import React, {useContext, useState, useEffect} from 'react'

import {makeStyles} from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import IconButton from '@material-ui/core/IconButton'
import CircularProgress from '@material-ui/core/CircularProgress';

import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd'
import TrackInfo from '../TrackInfo'

import _firebaseContext from '../../../contexts/firebaseContext'
import _appContext from '../../../contexts/appContext'
import Backdrop from "@material-ui/core/Backdrop";
import Button from "@material-ui/core/Button";
import firebase from "../../../utils/firebase";

export default function TracksPanel({planetId, languagesList, localeId, setLocaleId}) {
    const [currentTrackIndex, setCurrentTrackIndex] = useState(0)
    const [currentPlanetsLanguageIndex, setCurrentPlanetsLanguageIndex] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    const classes = useStyles()

    const firebaseContext = useContext(_firebaseContext)
    const appContext = useContext(_appContext)

    const matches = useMediaQuery('(max-width:767px)')

    useEffect(() => {
        firebaseContext.startTracksListener(planetId, localeId)

        return () => firebaseContext.closeTracksListener();
    }, [currentTrackIndex, localeId])

    const handleAddTrackBtnClick = async event => {
        setIsLoading(true);
        const newTrack = {
            name: 'new track',
            description: '',
            nightDescription: '',
            nightTrackTimespan: '0',
            trackTimespan: '0'
        }
        const result = await firebaseContext.addTrack(
            planetId,
            localeId,
            newTrack
        );
        if (!result.error) {
            await firebaseContext.updateCache();

            const lastAddedTrack = await firebaseContext.getLastAddedTrack(planetId, localeId);
            await firebaseContext.updateHistory(planetId, lastAddedTrack, 'onCreate', false);
        }
        setIsLoading(false);
        appContext.snackbar.showSnackbarMsg(result.message)
    }

    const handleDelete = async event => {
        setIsLoading(true);
        const indexBackup = currentTrackIndex

        setCurrentTrackIndex(0)
        const result = await firebaseContext.deleteTrack(
            planetId,
            localeId,
            tracks[currentTrackIndex].id
        )

        if (result.error) {
            setCurrentTrackIndex(indexBackup)
        }
        if (!result.error) {
            await firebaseContext.updateCache();
            await firebaseContext.updateHistory(planetId, tracks[currentTrackIndex], 'onDelete', false);
        }
        setIsLoading(false);
        appContext.snackbar.showSnackbarMsg(result.message)

        return result
    }

    const tracks = firebaseContext.data.tracks[planetId + localeId]

    return (
        <>
            <Tabs
                orientation={"horizontal"}
                variant="scrollable"
                onChange={(event, value) => {
                    setLocaleId(languagesList[value].id);
                    setCurrentTrackIndex(0);
                    setCurrentPlanetsLanguageIndex(value);
                }}
                value={currentPlanetsLanguageIndex}
                className={classes.tabs}
            >
                {
                    languagesList.map(language => {
                        if (!language.data || !language.data.represent) {
                            return null;
                        }
                        return <Tab key={language.id} label={language.data.represent}/>
                    })
                }
            </Tabs>

            {tracks === undefined ? (
                <CircularProgress color={'primary'} style={{marginLeft: 30, marginTop: 25}}/>
            ) : (
                <div className={classes.root}>
                    <div className={classes.playlistsTitle}>
                        <Typography
                            className={classes.tabsTitle}
                            color="textSecondary"
                        >
                            Список треков
                        </Typography>

                        <IconButton edge="end" onClick={handleAddTrackBtnClick}>
                            <PlaylistAddIcon/>
                        </IconButton>
                    </div>

                    <div
                        className={`${classes.tabsWrapper} ${
                            matches ? classes.column : classes.row
                        }`}
                    >
                        {tracks.length === 0 ? (
                            <Typography variant="body1">
                                В системе пока нет треков
                            </Typography>
                        ) : (
                            <>
                                <Tabs
                                    orientation={
                                        matches ? 'horizontal' : 'vertical'
                                    }
                                    variant="scrollable"
                                    onChange={(event, value) =>
                                        setCurrentTrackIndex(value)
                                    }
                                    value={currentTrackIndex}
                                    className={classes.tabs}
                                >
                                    {tracks.map(track => (
                                        <Tab
                                            key={track.id}
                                            label={track.data.name}
                                        />
                                    ))}
                                </Tabs>
                                <TrackInfo
                                    planetId={planetId}
                                    localeId={localeId}
                                    handleDelete={handleDelete}
                                    track={tracks[currentTrackIndex]}
                                    key={tracks[currentTrackIndex].id}
                                    setIsLoading={setIsLoading}
                                />
                            </>
                        )}
                    </div>
                </div>
            )}
            {
                isLoading &&
                <Backdrop style={{zIndex: 10000}} open={true}>
                    <CircularProgress style={{color: '#FFF'}}/>
                </Backdrop>
            }
        </>
    )
}

const useStyles = makeStyles(theme => ({
    root: {},
    tabsWrapper: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        display: 'flex'
    },
    column: {
        flexDirection: 'column',
    },
    row: {
        flexDirection: 'row',
    },
    tabs: {
        borderRight: `1px solid ${theme.palette.divider}`
    },
    tabsTitle: {
        display: 'block',
        marginTop: '15px',
        marginBottom: '15px',
    },
    playlistsTitle: {
        display: 'flex',
        alignItems: 'center',
    },
}))
